import { FC, useEffect, useState } from 'react';
import { formDataComsToTiled } from '../../config';
import SaleTarget from './components/SaleTarget';
import CostExpense from './components/CostExpense';
import OperatingIncome from './components/OperatingIncome';
import EmployeeCompensationCost from './components/EmployeeCompensationCost';
import StoreImageCost from './components/StoreImageCost';
import StoreEngineeringCost from './components/StoreEngineeringCost';
import LeaseCost from './components/LeaseCost';
import OtherCost from './components/OtherCost';
import { transferSubmitData } from './components/transfer2value';
import { isArray } from '@lhb/func';
import { CoreInfoRelateNames } from './ts-config';
import { Form } from 'antd';

/**
 * @Description 基诺浦交付-盈亏测算组件
 *  控件 提交、回显的参数格式
 */
const CalculationJNP: FC<{
  form: any;
  formItemData: any;
  disabled?: boolean;
  wholeFormData: any;
  infoChange: any;
}> = ({
  form,
  formItemData,
  disabled,
  wholeFormData,
  infoChange,
}) => {

  const [collaborationModeOptions, setCollaborationModeOptions] = useState<any[]>([]);

  // 核心信息计算相关的字段，合作模式、合同面积、员工数变动时触发组件数据计算
  const collaborationMode: any = Form.useWatch(CoreInfoRelateNames.collaborationMode, form);
  const basicUsableArea: any = Form.useWatch(CoreInfoRelateNames.basicUsableArea, form);
  const employeeStaffing: any = Form.useWatch(CoreInfoRelateNames.employeeStaffing, form);

  /**
   * @description 外部相关字段变动时：合作模式所有选项、合作模式选中项、合同面积、员工数，重新计算结果
   */
  useEffect(() => {
    onChange();
  }, [collaborationModeOptions, collaborationMode, basicUsableArea, employeeStaffing]);

  const onChange = () => {
    const allValues = form.getFieldsValue();
    const jnpValuesObj = allValues[formItemData.identification];
    const val = transferSubmitData(jnpValuesObj, form, collaborationModeOptions);
    infoChange && infoChange(formItemData.identification, val);
  };

  useEffect(() => {
    if (!isArray(wholeFormData.propertyGroupVOList)) {
      setCollaborationModeOptions([]);
      return;
    }

    const allComps: any = [];
    formDataComsToTiled(wholeFormData.propertyGroupVOList, allComps); // 将组件对象平铺到数组中
    // 合作模式字段
    const collProperty: any = allComps.find((item: any) => item.identification === CoreInfoRelateNames.collaborationMode);
    setCollaborationModeOptions(isArray(collProperty?.propertyConfigOptionVOList) ? collProperty?.propertyConfigOptionVOList : []);
  }, [wholeFormData]);

  return <>
    <SaleTarget
      form={form}
      formItemData={formItemData}
      disabled={disabled}
      onChange={onChange}
    />
    <OperatingIncome
      form={form}
      formItemData={formItemData}
      disabled={disabled}
      collaborationModeOptions={collaborationModeOptions}
      onChange={onChange}
    />
    <CostExpense
      form={form}
      formItemData={formItemData}
      disabled={disabled}
      onChange={onChange}
    />
    <EmployeeCompensationCost
      form={form}
      formItemData={formItemData}
      disabled={disabled}
      onChange={onChange}
    />
    <StoreImageCost
      form={form}
      formItemData={formItemData}
      disabled={disabled}
      onChange={onChange}
    />
    <StoreEngineeringCost
      form={form}
      formItemData={formItemData}
      disabled={disabled}
      onChange={onChange}/>
    <LeaseCost
      form={form}
      formItemData={formItemData}
      disabled={disabled}
      collaborationModeOptions={collaborationModeOptions}
      onChange={onChange}
    />
    <OtherCost
      form={form}
      formItemData={formItemData}
      disabled={disabled}
      onChange={onChange}
    />
  </>;
};

export default CalculationJNP;
